import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { CaoService } from 'src/app/services/cao.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
@Component({
  selector: 'app-all-subsidy-lot',
  templateUrl: './all-subsidy-lot.component.html',
  styleUrls: ['./all-subsidy-lot.component.scss']
})
export class AllSubsidyLotComponent implements OnInit {

  dropDownList: { type: any, value: any }[];
  applicationSelected: any;
  responseDate: any;
  cols: any[];

  constructor(
    private route: ActivatedRoute,
    private ipService: IpAddressService, 
    private caoService: CaoService, 
    private messageService: MessageService, 
    private router: Router,
    private activityRecordService: ActivityRecordService
    ) { }

  autoId: any;
  appId: any;
  items: any[];
  userID: any;

  ngOnInit(): void {
    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'View All Subsidy Lot', '', new Date(), 'Success');

    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
    this.dropDownList = [
      {
        type: 'Farmer Share To Vendor', value: `/all-subsidy-lot/mi-farmer-share-to-vendor/pfms`
      },
      {
        type: 'Subsidy To Farmer', value: `/all-subsidy-lot/mi-subsidy-to-farmer/pfms`
      },
      {
        type: 'Subsidy To Vendor', value: `/all-subsidy-lot/mi-subsidy-to-vendor/pfms`
      },
      {
        type: 'Refund To Farmer', value: `/all-subsidy-lot/mi-refund-to-farmer/pfms`
      },
      {
        type: 'Stage 1', value: `/all-subsidy-lot/pond/tank-stage1/pfms`
      },
      {
        type: 'Stage 2', value: `/all-subsidy-lot/pond/tank-stage2/pfms`
      },
      {
        type: 'Stage 3', value: `/all-subsidy-lot/pond/tank-stage3/pfms`
      },
    ]
  }

  onApplicationTypeSelected(event) {
    let parentRoute = this.router.url.split('/')[1];
    this.router.navigate([`/${parentRoute.concat(event.value.value)}`])
  }

}
